<template>
    <transition name="fade">
        <div class="modal-modal" @click.self="handleCancel" v-show="show" :style="{display: show ? 'block':'none', background: mask? 'rgba(0, 0, 0, 0.6)':  'rgba(0, 0, 0, 0)'}">
            <div class="modal-content" :style="{top: top}" >
                <img v-if="false" src="../assets/images/close@2x.png" alt="" class="icon-close" @click="handleCancel">
                <slot name="default">{{content}}</slot>
                <div class="btn-group">
                    <div class="btn btn-no" @click="handleCancel">{{cancelText}}</div>
                    <div class="btn btn-yes" @click="handleConfirm">{{okText}}</div>
                </div>
            </div>
        </div>
    </transition>

</template>

<script>
    export default {
        name: "Modal",
        props: {

        },
        data() {
            return {
                top: '0px',
                show: false,
                mask: true,
                // title: "标题", //标题
                type: "confirm", //类型
                content: "确认执行此动作？", //内容
                okText: "确定",
                cancelText: "取消",
                // width: "520px", //百分比或者字符串
            }
        },
        methods: {
            handleConfirm() {
                this.show = false;
                if(this.onOK){
                    this.onOK();
                }

            },
            handleCancel() {
                this.show = false;
                if(this.onCancel){
                    this.onCancel();
                }
            },
        },
        created() {
            this.top = (window.innerHeight - 310) / 2 + 'px'
        }
    }
</script>

<style scoped lang="scss">
    .modal-modal {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 999;
        cursor: auto;
        .modal-content {
            position: relative;
            width: 280px;
            height: 170px;
            background: white;
            margin:0 auto;
            border-radius: 15px;
            padding: 30px 20px;
            z-index: 1000;
            color: #404040;
            font-size: 14px;
            .icon-close {
                position: absolute;
                width: 20px;
                height: 20px;
                top: 10px;
                right: 10px;
                cursor: pointer;
            }

            .btn-group {
                position: absolute;
                bottom: 0;
                left: 0;
                right: 0;
                display: flex;
                justify-content: center;
                .btn {
                    width: 110px;
                    height: 40px;
                    line-height: 40px;
                    text-align: center;
                    margin:20px 5px;
                    font-size: 14px;
                    border-radius: 10px;
                    cursor: pointer;
                    &.btn-no {
                        border: 1px solid #E3E3E3;
                        color: #191A1C;
                    }
                    &.btn-yes {
                        background: #FA3D5A;
                        color: white;

                    }
                }
            }
        }
    }
</style>
